import React from 'react';
import AccessTimeIcon from '@material-ui/icons/AccessTime'
import { formatTime } from '../../../../../helpers/time.helper';


export const TimeStamp = ({ messages, color, timeStamp, lang }) => {
  if (!timeStamp) return null;
  return (
    <div
      style={{ color: messages.color || color, opacity: 0.8, textAlign: "center" }}
      className={"time-stamp-da"}
    >
      <AccessTimeIcon
        style={{ fontSize: 16, margin: "0px 3px", marginTop: -5 }}
      />
      {formatTime(timeStamp, lang)}
    </div>
  );
};
